<div class="field-header">
  <slot />
</div>

<style lang="scss" src="./header.scss"></style>
